<template>
    <div>
        <h2 class="title is-size-3 has-text-centered">Tu orden ha sido creada</h2>

        <div v-if="manualOrderValidation">
            <p class="has-text-centered">Te actualizaremos via email toda novedad de tu orden.</p>
            <p class="has-text-centered">Recibiras toda la informacion en el correo.</p>
        </div>

        <div v-else>
            <div v-if="payment.method == 'mp' || payment.method == 'pp'">
                <p class="has-text-centered">Tu orden y el pago se crearon con exito! </p>
                <p class="has-text-centered">Te mantendremos al tanto del estado de tu orden via email.</p>
            </div>
            <div v-if="payment.method == 'transfer'">
                <p class="has-text-centered">Ahora necesitamos que realices el pago usando uno de estos canales para darla como valida.</p>
                <div class="columns is-multiline m-t-30 is-centered">
                    <div v-for="x in channels" :key="x.id" class="column is-one-quarter">
                        <p class="has-text-weight-bold">{{x.title}}</p>
                        <p>{{x.dato1}} - {{x.dato2}} - {{x.dato3}} - {{x.dato4}} - {{x.dato5}}</p>
                    </div>
                </div>
            </div>
            <div v-if="payment.method == 'cash'">
                <p class="has-text-centered">
                    Elegiste pagar presencialmente.
                </p>
                <p class="has-text-centered" v-if="orderData.shipmentMethod == 'retiro'">
                    Podras pagar tu orden al momento de pasar a retirar.
                </p>
                <p class="has-text-centered" v-else-if="orderData.shipmentMethod == 'delivery'">
                    Podras pagar tu orden al momento de recibirla en tu casa.
                </p>
            </div>

        </div>
        <div v-if="!payment.method == 'mp'">
            <div v-if="userEmail.length" class="has-text-centered">
                <b-button
                class="has-text-centered"
                type="is-custom"
                rounded
                @click="goHome"
                >
                Volver al inicio
                </b-button>
            </div>
            <div v-else class="has-text-centered m-t-25">
                <p>Recuerda que si estas registrado, podes guardar tus datos para completar tus ordenes con un perfil guardado, y acceder a mas beneficios.</p>
                <b-button
                light
                rounded
                @click="goHome"
                type="is-text">
                    No, ir al inicio.
                </b-button>
                <b-button
                rounded
                @click="goRegister"
                type="is-success">
                    Registrarme
                </b-button>
            </div>
        </div>
        
    </div>
</template>

<script>
import { getHandler } from '../../../../services/http'
export default {
    props:{
        channels:{
            type:Array,
            default:new Array([])
        }, 
        payment:{
            type:Object,
            default:new Object({})
        },
        manualValidation:{
            type:String,
            default:""
        },
        userEmail:{
            type:String,
            default:""
        },
        orderData:{
            type:Object(),
            default: new Object()
        }
    },
    methods:{
        goHome(){
            window.location.href = '/'
        },
        goRegister(){
            window.location.href='/user/register/'
        }
    },
    computed:{
        manualOrderValidation(){
            return this.manualValidation == "True"
        }
    }
}
</script>

<style lang="scss" scoped>
.is-custom{
    background:var(--primary);
    color:var(--text-color);
}
</style>